import { render, staticRenderFns } from "./schulen.vue?vue&type=template&id=7dfcd562&scoped=true&"
import script from "./schulen.vue?vue&type=script&lang=js&"
export * from "./schulen.vue?vue&type=script&lang=js&"
import style0 from "./schulen.vue?vue&type=style&index=0&id=7dfcd562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfcd562",
  null
  
)

export default component.exports